export default {"src":"/_next/static/media/heart.ce5d6173.svg","height":17,"width":20};